// <search-overlay> — panel drops from the top; predictive results via section_id=predictive-search.
const R = window.ClRoutes || { predictive_search_url: '/search/suggest' };

class SearchOverlay extends HTMLElement {
  connectedCallback() {
    this.panel = this.querySelector('.sr-panel');
    this.veil = this.querySelector('.veil');
    this.input = this.querySelector('.sr-in');
    this.idle = this.querySelector('[data-search-idle]');
    this.results = this.querySelector('[data-search-results]');
    this.clearBtn = this.querySelector('[data-search-clear]');
    document.addEventListener('search:open', (e) => this.open(e.detail?.trigger));
    this.addEventListener('click', (e) => {
      if (e.target.closest('[data-search-close]')) { this.close(); return; }
      if (e.target.closest('[data-search-clear]')) { this.input.value = ''; this.update(); this.input.focus(); return; }
      const chip = e.target.closest('[data-q]');
      if (chip) { this.input.value = chip.dataset.q; this.update(); this.input.focus(); }
    });
    this.input.addEventListener('input', () => { clearTimeout(this.t); this.t = setTimeout(() => this.update(), 220); });
    this.onKey = (e) => { if (!this.isOpen) return; if (e.key === 'Escape') this.close(); if (e.key === 'Tab') this.trap(e); };
    document.addEventListener('keydown', this.onKey);
  }
  get isOpen() { return this.panel.classList.contains('open'); }
  open(trigger) {
    this.prev = trigger || document.activeElement;
    this.panel.classList.add('open'); this.veil.classList.add('open');
    this.panel.setAttribute('aria-hidden', 'false');
    document.documentElement.classList.add('lock');
    setTimeout(() => this.input.focus({ preventScroll: true }), 80);
  }
  close() {
    this.panel.classList.remove('open'); this.veil.classList.remove('open');
    this.panel.setAttribute('aria-hidden', 'true');
    document.documentElement.classList.remove('lock');
    this.prev?.focus?.({ preventScroll: true });
  }
  trap(e) {
    const f = [...this.panel.querySelectorAll('a[href], button:not([disabled]), input:not([type="hidden"])')].filter((el) => el.offsetParent !== null);
    if (!f.length) return;
    if (e.shiftKey && document.activeElement === f[0]) { e.preventDefault(); f[f.length - 1].focus(); }
    else if (!e.shiftKey && document.activeElement === f[f.length - 1]) { e.preventDefault(); f[0].focus(); }
  }
  async update() {
    const q = this.input.value.trim();
    this.clearBtn.hidden = !q;
    if (!q) { this.show(false); return; }
    this.ctrl?.abort(); this.ctrl = new AbortController();
    const url = `${R.predictive_search_url}?q=${encodeURIComponent(q)}&resources[type]=product,page,article&resources[limit]=6&resources[options][unavailable_products]=last&section_id=predictive-search`;
    try {
      const html = await fetch(url, { signal: this.ctrl.signal }).then((r) => r.text());
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const body = doc.querySelector('.shopify-section') || doc.body;
      this.results.replaceChildren(...body.childNodes);
      const copy = this.results.querySelector('[data-search-chips-copy]');
      if (copy) copy.innerHTML = this.querySelector('[data-search-chips]')?.innerHTML || '';
      this.show(true);
    } catch (err) { if (err.name !== 'AbortError') this.show(false); }
  }
  show(on) {
    this.results.hidden = !on; this.idle.hidden = on;
    this.input.setAttribute('aria-expanded', String(on));
  }
}
if (!customElements.get('search-overlay')) customElements.define('search-overlay', SearchOverlay);
